module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"Do you want to move future transactions too?":"Перенести ещё и будущие транзакции?","Or move only this one?":"Или только одну?","Move this one and future ones":"Перенести эту и будущие","Move only one":"Только эту"}}')
  delete Component.options._Ctor
}
